import { ApkFileData, ApkInfo } from '@/types/apk.types'
import { toastError } from './toast'

export function downloadApkFile(apk: ApkFileData): void {
  if (!apk.data || !apk.filename) {
    toastError('Aucune APK disponible au téléchargement')
    return
  }

  const binaryString = atob(apk.data)
  const bytes = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }

  const blob = new Blob([bytes], { type: 'application/vnd.android.package-archive' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = apk.filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export function getApkSourceLabel(source: ApkInfo['source']): string {
  switch (source) {
    case 'custom':
      return 'APK marque blanche'
    case 'inherited':
      return 'APK du grossiste'
    case 'default':
    default:
      return 'APK standard NeoSVPlus'
  }
}

export function formatApkActorName(info: ApkInfo): string | null {
  if (!info.inheritedFrom) return null
  const { companyName, firstname, lastname } = info.inheritedFrom
  return companyName?.trim() || `${firstname} ${lastname}`.trim()
}
